import { getGeneralLookupUsers } from "../../../api/divvy-generalLookup";

const generalLookup = {
  namespaced: true,
  state: () => ({
    generalLookupUsersData: null,
    searchTerm: "",
    pageNumber: 1,
  }),
  getters: {
    generalLookupUsersData: (state) => {
      return state.generalLookupUsersData;
    },
    searchTerm: (state) => {
      return state.searchTerm;
    },
    pageNumber: (state) => {
      return state.pageNumber;
    },
  },
  actions: {
    getGeneralLookupUsers({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        getGeneralLookupUsers(payload)
          .then((data) => {
            state.generalLookupUsersData = data;
            resolve(data);
          })
          .catch((err) => {
            console.log("getGeneralLookupUsers store", err);
          });
      });
    },
  },
  mutations: {
    SET_SEARCH_TERM: (state, value) => {
      state.searchTerm = value;
    },
    SET_PAGE_NUMBER: (state, val) => {
      state.pageNumber = val;
    }
  },
};

export default generalLookup;
